import $ from 'jquery'
import {actData} from "./publicnew";

export default function ActData(){

    this.serverUrl = "/cm-sites-activiti/activitiPublic/"

    this.allGroupUrl = this.serverUrl + "getAllGroup";
    this.allRole = this.serverUrl + "getAllRole";
    this.getUsers = this.serverUrl + "getUsers";


}

ActData.prototype.post = function(url,pram){
    let requestData ;
    let contentType =  'application/x-www-form-urlencoded';
    if(typeof pram == 'string'){
        contentType =  'application/json; charset=UTF-8';
    }
    $.ajax({
        url: url,
        data: pram,
        async:false,
        contentType: contentType,
        dataType:"JSON",
        type:"POST",
        success: function(result){
            if(typeof result == 'string'){
                requestData = JSON.parse(result);
            }else{
                requestData = result;
            }
        },
        error:function(e){
            console.log(e);
        },
        beforeSend: function(xhr) {
            xhr.setRequestHeader("userName",actData.userName);
        }
    });
    return requestData;
}

/**
 * 获取所有的部门
 */
ActData.prototype.getAllGroup = function () {
    return this.post(this.allGroupUrl,null);
}
ActData.prototype.getAllRole = function () {
    return this.post(this.allRole,null);
}

ActData.prototype.getGroupByIds = function (ids) {
    let json = new Array();
    let data= this.getAllGroup();
    $.each(data,function(index,item){
        if(ids.indexOf(item.id) > -1){
            json.push(item);
        }
    })
    return json;
}

ActData.prototype.getRoleByIds = function (ids) {
    let json = new Array();
    let data= this.getAllRole();
    $.each(data,function(index,item){
        if(ids.indexOf(item.id) > -1){
            json.push({
                id:item.id,
                name:item.roleName
            });
        }
    })
    return json;
}

ActData.prototype.getUser = function (pram) {
    if(typeof(window.chooseFilterObject) != 'undefined'){
        let jsonArray = this.post(this.getUsers,JSON.stringify(pram));
        window.chooseFilterObject.data = jsonArray;
        jsonArray = this.post(window.chooseFilterObject.url,JSON.stringify(window.chooseFilterObject));
        return jsonArray;
    }else {
        return this.post(this.getUsers,JSON.stringify(pram));
    }
};